import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import UnitPage from "./pages/UnitPage";
import ValuePage from "./pages/ValuePage";
import ViewClasses from "./pages/ViewClasses";
import ClassCreator from "./components/ClassCreator";
import GroupPage from "./pages/GroupPage";
import DashboardPage from "./pages/Dashboard";
import UnitPageNew from "./pages/UnitPageNew";
import LoginPage from "./user/login";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import ProtectedRoute from "./protectedRoute";
import themeConfig from "./config/themeConfig";
import ValuePageNew from "./pages/ValuePageNew";
import AddGroup from "./components/Forms/Group/AddGroup";
import AddUnit from "./components/Forms/Unit/AddUnit";
import AddValue from "./components/Forms/Value/AddValue";
import FeaturePageNew from "./pages/FeaturePageNew";
import AddFeature from "./components/Forms/Feature/AddFeature";
import FeatureGroupPage from "./pages/FeatureGroupPage";
import AddFeatureGroup from "./components/Forms/FeatureGroup/AddFeatureGroup";
import ClassesPageNew from "./pages/ClassesPageNew";
import AddClass from "./components/Forms/Class/AddClass";
import IncludedFeaturesPage from "./components/Forms/Class/IncludedFeatures/IncludedFeaturesPage";
import Layout from "./Layout";
import EditFeature from "./components/Forms/Feature/EditFeature";
import EditValue from "./components/Forms/Value/EditValue";
import EditUnit from "./components/Forms/Unit/EditUnit";
import EditFeatureGroup from "./components/Forms/FeatureGroup/EditFeatureGroup";
import EditGroup from "./components/Forms/Group/EditGroup";
import EditIncludedFeatures from "./components/Forms/Class/IncludedFeatures/EditIncludedFeatures";
import NotFoundPage from "./pages/NotFoundPage";
import EditClass from "./components/Forms/Class/EditClass";
import ProductPage from "./pages/Products_with_info";
import CustomerContactPage from "./pages/CustomerContactPage";

const theme = createTheme({
  palette: {
    primary: themeConfig.palette.primary,
    secondary: themeConfig.palette.secondary,
    brand: themeConfig.palette.brand,
    shell: themeConfig.palette.shell,
  },
  occtooEnable: themeConfig.isOcctooEnable,
  typography: themeConfig.typography,
  custom: {
    avensiaLogo: themeConfig.avensiaLogo,
    alligoLogo: themeConfig.alligoLogo,
    avensiaGuyLogo: themeConfig.avensiaGuyLogo,
  },
  shape: {
    borderRadius: 2,
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "small",
        fullWidth: true,
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          color: "#6b7280",
        },
        "&.Mui-focused": {
          color: "#4f46e5",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#f9fafb",
          transition: "all 0.2s ease",

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e5e7eb",
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#6366f1",
          },

          "&.Mui-focused": {
            backgroundColor: "#ffffff",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#4f46e5",
            borderWidth: "2px",
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/notfound" element={<NotFoundPage />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route index element={<DashboardPage />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="units" element={<UnitPage />} />
              <Route path="values" element={<ValuePage />} />
              <Route path="classes" element={<ViewClasses />} />
              <Route path="create" element={<ClassCreator />} />
              <Route path="groups" element={<GroupPage />} />
              <Route path="groups/new" element={<AddGroup />} />
              <Route path="units/new" element={<AddUnit />} />
              <Route path="values/new" element={<AddValue />} />
              <Route path="unitsnew" element={<UnitPageNew />} />
              <Route path="featuresnew" element={<FeaturePageNew />} />
              <Route path="featuregroups" element={<FeatureGroupPage />} />
              <Route path="featuregroups/new" element={<AddFeatureGroup />} />
              <Route path="product" element={<ProductPage />} />
              <Route path="customers" element={<CustomerContactPage />} />
              <Route
                path="featuregroup/edit/:id"
                element={<EditFeatureGroup />}
              />
              <Route path="features/new" element={<AddFeature />} />
              <Route path="feature/edit/:id" element={<EditFeature />} />
              <Route path="valuesnew" element={<ValuePageNew />} />
              <Route path="value/edit/:id" element={<EditValue />} />
              <Route path="unit/edit/:id" element={<EditUnit />} />
              <Route path="group/edit/:id" element={<EditGroup />} />
              <Route path="classnew" element={<ClassesPageNew />} />
              <Route path="classes/new" element={<AddClass />} />
              <Route path="class/edit/:id" element={<EditClass />} />
              <Route
                path="classes/:classCode/includedfeature/edit/:featureId"
                element={<EditIncludedFeatures />}
              />
              <Route
                path="classes/:id/includedfeatures"
                element={<IncludedFeaturesPage />}
              />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
